{
    "OWNER_MASTER_SAFECO_AGENCY_CD": "",
    "SPECIALTY_YTD_RETENTION": "0",
    "HOME_PR_3_MTD_ISSUE_CNT": "0",
    "SPECIALTY_RLNG12_NB_MIX_RATIO": "0",
    "YTD_ISSUE_CNT": "0",
    "AUTO_BI_LT_50_100_PCT": "0",
    "HOME_RLNG12_ISSUE_CNT": "0",
    "ESIGN_PND_CNT": "0",
    "AUTO_YTD_LOSS_RATIO": "0",
    "SUBSTAT": "",
    "CORE_AGCY_CD": "0",
    "HOME_RLNG12_QUOTE_CNT": "0",
    "AUTO_BI_GT_300_PCT": "0",
    "SPECIALTY_YTD_ISSUE_CNT": "0",
    "HOME_YTD_LOSS_RATIO": "0",
    "SPECIALTY_YTD_QUOTE_CNT": "0",
    "HOME_YTD_RETENTION": "0",
    "SPECIALTY_PR_3_MTD_QTE_CNT": "0",
    "ROLLING12_ISSUE_CNT": "0",
    "SPECIALTY_PIF_CNT": "0",
    "AUTO_YTD_ISSUE_CNT": "0",
    "HOME_PR_3_MTD_QTE_CNT": "0",
    "AUTO_PR_3_MTD_ISSUE_CNT": "0",
    "YTD_QUOTE_CNT": "0",
    "ROLLING12_DWP_AMT": "0",
    "SPECIALTY_PIF_MIX_RATIO": "0",
    "HOME_YTD_QUOTE_CNT": "0",
    "HOME_PIF_CNT": "0",
    "AUTO_YTD_RETENTION": "0",
    "CLNDR_DT": "",
    "AUTO_PIF_CNT": "0",
    "PR_3_MTD_QTE_CNT": "0",
    "YTD_LOSS_RATIO": "0",
    "PR_3_MTD_ISSUE_CNT": "0",
    "LOCATION": "",
    "RLNG12_QUOTE_CNT": "0",
    "AUTO_RLNG12_ISSUE_CNT": "0",
    "AUTO_TO_HOME_YTD_NB_RATIO": "0",
    "AUTO_TO_HOME_PIF_RATIO": "0",
    "AUTO_RLNG12_QUOTE_CNT": "0",
    "TWOYR_PLUS_YTD_LOSS_RATIO": "0",
    "NOT_SNGL_FMLY_DWLNG_PCT": "0",
    "AUTO_YTD_QUOTE_CNT": "0",
    "AUTO_PR_3_MTD_QTE_CNT": "0",
    "YTD_DWP_AMT": "0",
    "SPECIALTY_RLNG12_ISSUE_CNT": "0",
    "SPECIALTY_RLNG12_QUOTE_CNT": "0",
    "COVA_GT_500K_PCT": "0",
    "SPECIALTY_YTD_LOSS_RATIO": "0",
    "HOME_YTD_ISSUE_CNT": "0",
    "AUTO_STD_NSTD_PCT": "0",
    "SPECIALTY_YTD_NB_MIX_RATIO": "0",
    "PIF_GROWTH_RATE": "0",
    "YTD_RETENTION": "0",
    "PRIOR_YE_RETENTION": "0",
    "AUTO_TO_HOME_RLNG12_NB_RATIO": "0",
    "SPECIALTY_PR_3_MTD_ISSUE_CNT": "0",
    "PIF_CNT": "0",
    "ALL_LOBS_R12_CANCELS": "0",
    "ALL_LOBS_YTD_CANCELS": "0",
    "ALL_LOBS_PRIOR_90_CANCELS": "0",
    "ALL_LOBS_MTD_CANCELS": "0",
    "PCT_OF_AUTO_QUOTES_BI_LIMITS_MORE_THAN_100_300": "0",
    "PCT_OF_HOMES_WITH_SERVICE_LINE_CYBER_ETC_ENDORSE": "0",
    "PCT_OF_QUOTES_IN_HIGHEST_COVERAGE_LEVEL": "0",
    "PCT_QUOTES_IN_LOWEST_COVERAGE_LEVEL": "0",
    "PCT_QUOTES_WITH_NHNS": "0",
    "AUTO_TICKETS_OR_ACCIDENTS": "0",
    "AVERAGE_CREDIT_DECILE_ISSUES": "0",
    "AVERAGE_CREDIT_DECILE_QUOTES": "0",
    "AVERAGE_TENURE_WITH_PRIOR_CARRIER": "0",
    "AVERAGE_VEHICLE_COUNT": "0",
    "CONDO_MTD_ISSUE_CNT": "0",
    "CONDO_MTD_QTE_CNT": "0",
    "CONDO_PIF_CNT": "0",
    "CONDO_PR3_ISSUE_CNT": "0",
    "CONDO_PR3_QTE_CNT": "0",
    "CONDO_ROLLING12_ISSUE_CNT": "0",
    "CONDO_ROLLING12_QTE_CNT": "0",
    "CONDO_YTD_ISSUE_CNT": "0",
    "CONDO_YTD_QTE_CNT": "0",
    "LANDLORD_MTD_ISSUE_CNT": "0",
    "LANDLORD_MTD_QTE_CNT": "0",
    "LANDLORD_PIF_CNT": "0",
    "LANDLORD_PR3_ISSUE_CNT": "0",
    "LANDLORD_PR3_QTE_CNT": "0",
    "LANDLORD_ROLLING12_ISSUE_CNT": "0",
    "LANDLORD_ROLLING12_QTE_CNT": "0",
    "LANDLORD_YTD_ISSUE_CNT": "0",
    "LANDLORD_YTD_QTE_CNT": "0",
    "MOTORCYCLE_MTD_ISSUE_CNT": "0",
    "MOTORCYCLE_MTD_QTE_CNT": "0",
    "MOTORCYCLE_PIF_CNT": "0",
    "MOTORCYCLE_PR3_ISSUE_CNT": "0",
    "MOTORCYCLE_PR3_QTE_CNT": "0",
    "MOTORCYCLE_ROLLING12_ISSUE_CNT": "0",
    "MOTORCYCLE_ROLLING12_QTE_CNT": "0",
    "MOTORCYCLE_YTD_ISSUE_CNT": "0",
    "MOTORCYCLE_YTD_QTE_CNT": "0",
    "RENTERS_MTD_ISSUE_CNT": "0",
    "RENTERS_MTD_QTE_CNT": "0",
    "RENTERS_PIF_CNT": "0",
    "RENTERS_PR3_ISSUE_CNT": "0",
    "RENTERS_PR3_QTE_CNT": "0",
    "RENTERS_ROLLING12_ISSUE_CNT": "0",
    "RENTERS_ROLLING12_QTE_CNT": "0",
    "RENTERS_YTD_ISSUE_CNT": "0",
    "RENTERS_YTD_QTE_CNT": "0",
    "UMBRELLA_MTD_ISSUE_CNT": "0",
    "UMBRELLA_MTD_QTE_CNT": "0",
    "UMBRELLA_PIF_CNT": "0",
    "UMBRELLA_PR3_ISSUE_CNT": "0",
    "UMBRELLA_PR3_QTE_CNT": "0",
    "UMBRELLA_ROLLING12_ISSUE_CNT": "0",
    "UMBRELLA_ROLLING12_QTE_CNT": "0",
    "UMBRELLA_YTD_ISSUE_CNT": "0",
    "UMBRELLA_YTD_QTE_CNT": "0",
    "WATERCRAFT_MTD_ISSUE_CNT": "0",
    "WATERCRAFT_MTD_QTE_CNT": "0",
    "WATERCRAFT_PIF_CNT": "0",
    "WATERCRAFT_PR3_ISSUE_CNT": "0",
    "WATERCRAFT_PR3_QTE_CNT": "0",
    "WATERCRAFT_ROLLING12_ISSUE_CNT": "0",
    "WATERCRAFT_ROLLING12_QTE_CNT": "0",
    "WATERCRAFT_YTD_ISSUE_CNT": "0",
    "WATERCRAFT_YTD_QTE_CNT": "0"
}